module.exports = __webpack_public_path__ + "img/thumbs-up-filled.6e42cc30.png";